import Crypto from 'crypto-js'
let __getCookie = c_name => {
  let c_start = document.cookie.indexOf(c_name + "="), value
  if (c_start != -1) {
    c_start = c_start + c_name.length + 1
    let c_end = document.cookie.indexOf(";", c_start)
    if (c_end == -1) c_end = document.cookie.length
    value = document.cookie.substring(c_start, c_end)
    return Crypto.AES.decrypt(value, 'secret key 123').toString(Crypto.enc.Utf8)
  }
  return ""
}

export default {
  /*设置cookie*/
  setCookie(name, value, expire = 10 * 365 * 24 * 60 * 60) {
    let encrypted = Crypto.AES.encrypt(value + '', 'secret key 123')
    let date = new Date()
    date.setTime(date.getTime() + expire * 1000)
    document.cookie = `${name}=${encrypted};expires=${date.toGMTString()}`
    return this
  },

  /*获取cookie*/
  getCookie(...c_names) {
    let result = {}
    if (c_names.length == 1) {
      result = __getCookie(...c_names)
    } else {
      c_names.forEach(c_name => {
        result[c_name] = __getCookie(c_name)
      })
    }
    return result
  },

  /*删除cookie*/
  delCookie(...c_names) {
    c_names.forEach(item => {
      this.setCookie(item, "", -1)
    })
    return this
  }
}
